import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";






const JavaScriptLesson21 = () => {
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <h3>Composite Data Types</h3>
   <p>JavaScript supports the following composite data types:</p>
   <ol class="list-group list-group-numbered mb-4">
     <li class="list-group-item">Object</li>
     <li class="list-group-item">Array</li>
     <li class="list-group-item">Function</li>
   </ol>


    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson21